export default __webpack_public_path__ + "static/media/949.7e109cfb.gif";